import React, { Component } from "react";
import languagePicker from "./languages/languages";
import Generator from "./routes/generator";
import Landing from "./routes/landing";
import { Route, Switch } from "react-router-dom";
import Encyclopedia from "./routes/encyclopedia";
import EncyclopediaPost from "./routes/encyclopediaPost";
import Insurance from "./routes/insurance";
import RoomLayout from "./routes/room";
import { Helmet } from "react-helmet";
import Inshu from "./routes/inshu";
import VirtualTour from "./routes/virtualTour";
import Admin from "./routes/admin";
import Preview from "./components/rug/preview";

class App extends Component {
  constructor(props) {
    super(props);
    // Get data required to render the page according to user language
    const { texts, language, themeDirection } = languagePicker(
      window.location.search
    );
    this.state = {
      isAuthenticated: true,
      texts: texts,
      language: language,
      themeDirection: themeDirection,
    };
  }

  handleLangSwitch = (lang) => {
    // const texts = textsPicker(lang);
    // const direction = themeDirectionPicker(lang);
    const { texts, language, themeDirection } = languagePicker(null, lang);
    this.setState({
      texts: texts,
      themeDirection: themeDirection,
      language: language,
    });
  };

  render() {
    return (
      <>
        {this.state.themeDirection === "ltr" && (
          <Helmet>
            <link rel="stylesheet" href="/static/css/ltr-style.min.css" />
          </Helmet>
        )}
        <Switch>
          <Route
            exact
            path={"/"}
            render={(props) => (
              <Landing
                globalState={this.state}
                langHandler={this.handleLangSwitch}
                {...props}
                texts={this.state.texts}
              />
            )}
          />
          <Route
            exact
            path={"/admin"}
            render={(props) => (
              <Admin
                globalState={this.state}
                langHandler={this.handleLangSwitch}
                {...props}
                texts={this.state.texts}
              />
            )}
          />
          <Route
            exact
            path={"/generator"}
            render={(context) => (
              <Generator
                texts={this.state.texts}
                globalState={this.state}
                context={context}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/wiki"}
            render={() => (
              <Encyclopedia
                texts={this.state.texts}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/virtualTour"}
            render={() => (
              <VirtualTour
                texts={this.state.texts}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/wiki/:postID"}
            render={(context, match) => (
              <EncyclopediaPost
                texts={this.state.texts}
                context={context}
                match={match}
              />
            )}
          />
          <Route
            exact
            path={"/preview"}
            render={(context) => (
              <Preview
                texts={this.state.texts}
                context={context}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/replace-rug"}
            render={(context) => (
              <Inshu
                texts={this.state.texts}
                context={context}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/insurance"}
            render={(context) => (
              <Insurance
                texts={this.state.texts}
                context={context}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/room"}
            render={(context) => (
              <RoomLayout
                texts={this.state.texts}
                context={context}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          {/* <Route exact path={'/reset/:key'} render={({ match }) => <ResetPassword texts={this.state.texts} match={match} />} /> */}
        </Switch>
      </>
    );
  }
}

export default App;
